// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { Box, useTheme } from '@mui/system';
import React from 'react';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Slide, Typography } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import CloseIcon from '@mui/icons-material/Close';
import styleDef from './styles';

interface DeleteFolderDialogProps {
  showDialog: boolean;
  loading?: boolean;
  setShowDialog: (show: boolean) => void;
  onDelete: () => void;
}

const Transition = React.forwardRef<unknown, TransitionProps>((props, ref) => <Slide ref={ref} direction="up" {...props} />);

const DeleteFolderDialog = ({ showDialog, loading, setShowDialog, onDelete }: DeleteFolderDialogProps) => {
  const theme = useTheme();
  const styles = styleDef(theme);

  return (
    <Dialog
      open={showDialog}
      onClose={() => setShowDialog(false)}
      TransitionComponent={Transition}
      keepMounted={false}
      sx={styles.dialog}
    >
      <Box sx={styles.titleSection}>
        <DialogTitle sx={styles.dialogTitle}>
          Delete Folder
        </DialogTitle>
        <IconButton
          color="inherit"
          onClick={() => setShowDialog(false)}
          aria-label="Close"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
      <DialogContent>
        <Typography variant="body1" sx={styles.dialogText}>
          Deleting this folder will unassign all projects inside it and move them to the dashboard. Are you sure you want to proceed?
        </Typography>
      </DialogContent>
      <DialogActions sx={styles.dialogActions}>
        <Button onClick={() => setShowDialog(false)} sx={styles.actionButtons}>
          Close
        </Button>
        <Button
          onClick={onDelete}
          disabled={loading}
          variant="contained"
          sx={styles.actionButtons}
        >
          {loading ? (
            <CircularProgress size={24} sx={styles.buttonProgress} />
          ) : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteFolderDialog.defaultProps = {
  loading: false,
};

export default DeleteFolderDialog;
